import { render, staticRenderFns } from "./AppointmentQuoteShareInfo.vue?vue&type=template&id=5dcb4a6c&"
import script from "./AppointmentQuoteShareInfo.vue?vue&type=script&lang=js&"
export * from "./AppointmentQuoteShareInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VTooltip})
